<template>
  <div class="hero">
    <div class="info-box">
      <div class="title">
        <h2>Info</h2>
      </div>
      <p>Computer Engineering student on his
        third year, anxious to learn, develop
        and be part of great projects and
        challenges that push himself away
        from the comfort zone and broaden
        his mind. Wanting to experiment and
        learn any kind of app making
        technology (Web, Android, IOS) and
        anything related to AI and Machine
        Learning
      </p>
    </div>
    <div class="info-box">
      <div class="title">
        <h2>Programming</h2>
      </div>
      <div class="grid">
        <div v-for="programming in programmingLangs" :key="programming.id">
          <skill-graph :skill="programming"/>
        </div>
      </div>
    </div>
    <div class="info-box">
      <div class="title">
        <h2>Languages</h2>
      </div>
      <div class="grid">
        <div v-for="language in languages" :key="language.id">
          <skill-graph :skill="language"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkillGraph from "./children/SkillGraph";
import programmingLangs from "../../static/docs/programmingLangs.json"
import languages from "../../static/docs/languages.json"
export default {
  name: "AboutMe",
  components: {
    SkillGraph
  },
  data() {
    return {
      programmingLangs: programmingLangs,
      languages: languages
    }
  },
  methods: {
  }
};
</script>

<style scoped>

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  margin-bottom: 20px;
}

.title {
  background-color: rgba(238, 237, 237);
  padding: 5px;
  margin-bottom: 10px;
  
}

.info-box {
  margin-bottom: 20px;
  border: solid 1px rgba(238, 237, 237);
  z-index: -1;
}

</style>



// WEBPACK FOOTER //
// src/components/AboutMe.vue